import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const ConfirmOrder = createAsyncThunk(
  "cartData/confirmOrder",
  async (_, thunkAPI) => {
    try {
      const storedUuid = localStorage.getItem("uuid");
      const Token = localStorage.getItem("loginData");
      const response = await axios.post(
        endPoint.CHECKOUT,
        {},
        {
          headers: {
            sessionId: storedUuid ? storedUuid : "",
            Authorization: Token ? `Bearer ${Token}` : "",
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const ConfirmOrderSlice = createSlice({
  name: "OrderConfirm",
  initialState: {
    OrderConfirm: [],
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ConfirmOrder.fulfilled, (state, action) => {
        state.OrderConfirm = action.payload;
      })
      .addCase(ConfirmOrder.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default ConfirmOrderSlice.reducer;
